import {
  createVariable,
  isVariable
} from "@tamagui/core";
const createTokens = (tokens) => createVariables(tokens), cache = /* @__PURE__ */ new WeakMap(), createVariables = (tokens, parentPath = "") => {
  if (cache.has(tokens)) return tokens;
  const res = {};
  for (const keyIn in tokens) {
    const val = tokens[keyIn], isPrefixed = keyIn[0] === "$", keyWithPrefix = isPrefixed ? keyIn : `$${keyIn}`, key = isPrefixed ? keyWithPrefix.slice(1) : keyIn;
    if (isVariable(val)) {
      res[key] = val;
      continue;
    }
    if (val && typeof val == "object") {
      res[key] = createVariables(tokens[key], keyIn);
      continue;
    }
    const cssKey = /^\d+$/.test(keyIn) ? `bn-${keyIn}` : keyIn, name = `${parentPath}-${cssKey}`, finalValue = isVariable(val) ? val : createVariable({ val, name, key: keyWithPrefix });
    res[key] = finalValue;
  }
  return cache.set(res, !0), res;
};
export {
  createTokens,
  createVariables
};
